import Api from '@/services/Api'

const URL = '/conta/poliza/';
const ACTION_AGREGAR_DETALLE = 'agregar_detalle';
const ACTION_ELIMINAR_DETALLE = 'eliminar_detalle';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_IMPRIMIR = 'imprimir';
const ACTION_ENVIAR_FEL = 'enviar_fel';

export default {
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if (params.id) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    agregar_detalle(id, params) {
        return Api().post(`${URL}${id}/${ACTION_AGREGAR_DETALLE}/`, params);

    },
    eliminar_detalle(id, params) {
        return Api().post(`${URL}${id}/${ACTION_ELIMINAR_DETALLE}/`, params);

    },
    abrir(id) {
        return Api().post(`${URL}${id}/${ACTION_ABRIR}/`);
    },
    cerrar(id) {
        return Api().post(`${URL}${id}/${ACTION_CERRAR}/`);
    },
    anular(id) {
        return Api().post(`${URL}${id}/${ACTION_ANULAR}/`);
    },
    imprimir(id) {
        return Api().post(`${URL}${id}/${ACTION_IMPRIMIR}/`);
    },
    enviar_fel(id) {
        return Api().post(`${URL}${id}/${ACTION_ENVIAR_FEL}/`);
    },

}